import styled from '@emotion/styled';
import React from 'react';

import { FeedbackStep } from '../pages/RateVideoSessionPage';

interface WrapperProps {
    visible: boolean;
    width: number | undefined;
}

const Wrapper = styled.div<WrapperProps>(props => ({
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: props.width,
    transition: `opacity ${props.visible ? '.5s' : '.2s'} ease-in-out`,
    opacity: props.visible ? 1 : 0,
    zIndex: props.visible ? 5 : -1,
}));

interface InnerWrapperProps {
    maxWidth: string | number;
}

const InnerWrapper = styled.div<InnerWrapperProps>(props => ({
    width: '100%',
    maxWidth: props.maxWidth,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'visible',
}));

interface Props {
    activeStep: FeedbackStep;
    visibleFor: FeedbackStep;
    width: number | undefined;
    fullWidth?: boolean;
    innerWrapperMaxWidth?: number;
}

export const RateSessionStepWrapper: React.FC<Props> = ({
    children,
    activeStep,
    visibleFor,
    width,
    fullWidth = false,
    innerWrapperMaxWidth = 500,
}) => {
    const isActive = activeStep === visibleFor;

    const maxWidth = 1440;
    const widthToApply = width && width > maxWidth ? maxWidth : width;

    return (
        <Wrapper
            visible={isActive}
            data-testid={'RateSessionStep-' + visibleFor}
            width={widthToApply}
        >
            <InnerWrapper maxWidth={fullWidth ? '100%' : innerWrapperMaxWidth}>
                {children}
            </InnerWrapper>
        </Wrapper>
    );
};
